import gsap from "gsap";
import { gameAssets } from "./gameUI";
import { fruitData } from "./data";
import { updateBucketAmount } from "./gameLogic";

function burstCoins(sprites, distance = 150, duration = 0.6, container) {
    if (!sprites || sprites.length !== 3) {
        console.error("burstCoins requires exactly 3 sprites.");
        return;
    }

    const anglesX = [30, -40, 95];
    const anglesY = [-50, 40, 40]

    sprites.forEach((sprite, i) => {
        const originalX = sprite.x;
        const originalY = sprite.y;
        const originalScaleX = sprite.scale.x;
        const originalScaleY = sprite.scale.y;

        const bucketAmountGlobalPos = gameAssets.bucketAmount.parent.toGlobal(gameAssets.bucketAmount.position);

        // Convert it into the container's parent space
        const targetPos = container.parent.toLocal(bucketAmountGlobalPos);

        gsap.timeline()
            .to(sprite.scale, {
                x: originalScaleX * 1.3,
                y: originalScaleY * 1.3,
                duration: 0.15,
                ease: "power1.out"
            })
            .to(sprite, {
                x: anglesX[i],
                y: anglesY[i],
                duration: 0.4,
                ease: "power2.out"
            }, "-=0.05")
            .to(sprite, {
                x: originalX,
                y: originalY,
                duration: 0.9,
                ease: "power2.inOut"
            })
            .to(sprite.scale, {
                x: originalScaleX,
                y: originalScaleY,
                duration: 0.7,
                ease: "back.out(1.7)",
                onComplete: () => {
                    gsap.to(container, {
                        x: targetPos.x,
                        y: targetPos.y,
                        scaleX: 0.2,
                        scaleY: 0.2,
                        alpha: 0,
                        duration: 0.6,
                        ease: "power2.inOut",
                        onComplete: () => {
                            container.visible = false;
                            container.scale.set(1);
                            container.alpha = 1;
                        }
                    });
                }
            }, "<")

    });
}

export { burstCoins }